module.exports = {
    "collapse": `Zwi\u{144}`,
    "expand": `Rozwi\u{144}`
};


//# sourceMappingURL=pl-PL.main.js.map
